import { Skeleton } from '@/shared/ui/Skeleton';

export function GoalsSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="flex justify-between items-center">
        <Skeleton width={200} height={32} />
        <Skeleton width={120} height={40} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <Skeleton width="100%" height={400} />
        </div>
        <div>
          <Skeleton width="100%" height={400} />
        </div>
      </div>
    </div>
  );
}
